import { TRfRegion } from '@/common/types/regionRf';
import { getUserRegionsRfIds } from '@/common/utils/userProfile';

export const getFilteredRegionsForUserRole = (regionsList: TRfRegion[]) => {
  const { isSubjectRfRole, userRegionRfIds } = getUserRegionsRfIds();

  return isSubjectRfRole
    ? regionsList.filter((region: { id: number }) => userRegionRfIds.includes(region.id))
    : regionsList;
};
